import React from 'react'
import PropTypes from 'prop-types'
import { Editor as PlainTextEditor } from 'draft-js'
import RichTextEditor from '../../sitewide/RichTextEditor'

const MessageEditor = ({
  blockRendererFn,
  bodyState,
  hideImgPicker,
  isBlastEmail,
  isEmail,
  placeholder,
  plugins,
  handleTemplateSelection,
  updateBodyState,
  openOptionsModal,
  optionsModalOpen,
  openCreateTemplateModal,
  createModalOpen,
  closeOptionsModal,
  templateSettings,
}) => (
  <div>
    {isEmail ? (
      <RichTextEditor
        openCreateTemplateModal={openCreateTemplateModal}
        createModalOpen={createModalOpen}
        blockRendererFn={blockRendererFn}
        editorState={bodyState}
        hideImgPicker={hideImgPicker}
        isBlastEmail={isBlastEmail}
        isEmail={isEmail}
        placeholder={placeholder}
        plugins={plugins}
        handleTemplateSelection={handleTemplateSelection}
        showExtraButtons={isBlastEmail}
        updateBodyState={updateBodyState}
        openOptionsModal={openOptionsModal}
        optionsModalOpen={optionsModalOpen}
        closeOptionsModal={closeOptionsModal}
        templateSettings={templateSettings}
      />
    ) : (
      <PlainTextEditor
        plugins={plugins}
        editorState={bodyState}
        onChange={updateBodyState}
        placeholder={placeholder}
      />
    )}
  </div>
)

MessageEditor.propTypes = {
  blockRendererFn: PropTypes.func,
  bodyState: PropTypes.shape({
    _immutable: PropTypes.object,
  }),
  isBlastEmail: PropTypes.bool,
  isEmail: PropTypes.bool,
  hideImgPicker: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  plugins: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        blockRendererFn: PropTypes.func,
        decorator: PropTypes.arrayOf(
          PropTypes.shape({
            component: PropTypes.func,
            strategy: PropTypes.func,
          }),
        ),
        initialize: PropTypes.func,
      }),
    ),
  ),
  updateBodyState: PropTypes.func.isRequired,
}

export default MessageEditor



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/MessageEditor.js